"use client";
import { SwitchButton } from "@commerce-frontend/ui/components/SwitchButton/SwitchButton";
import { useVat } from "@commerce-frontend/ui/providers/VatProvider";
import { useTranslations } from "next-intl";

export function VatSwitch() {
	const t = useTranslations("Header");

	const { includingVat, onVatChange, setVatModalIsOpen } = useVat();

	return (
		<div className="flex items-center gap-2">
			<SwitchButton checked={includingVat} onChange={onVatChange} size="sm" />

			<button
				type="button"
				onClick={() => setVatModalIsOpen(true)}
				aria-label={t("accessibilityOpenVatModal")}
			>
				{t("includingVat")}
			</button>
		</div>
	);
}
